// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_foundation.js"
import "./app.js"
import "jquery-lazy/jquery.lazy.min"

jQuery(document).ready(() => {
    $('.lazy').lazy();
 });



// WEBPACK FOOTER //
// ./js/main.js